import { call } from "./tasks";

/* ══ 게시판(운영 할 일) — `/chores` · `crates/api/src/chores.rs` · `docs/decisions/chores.md` ══
   에이전트가 남긴 사람 손일 + 사람이 남긴 메모. 고치기 · 끝내기 · 지우기는 사람만이다(서버가 막는다). */

export type Chore = {
  id: string;
  title: string;
  body: string | null;
  /** http(s) 주소면 링크, 아니면 문서 경로 · 명령 글자 그대로. */
  link: string | null;
  createdBy: string;
  /** 신원에서 정한 작성자 — 본문의 actor 가 아니다. */
  authorKind: "human" | "agent";
  createdAt: string;
  updatedAt: string;
  doneAt: string | null;
  doneBy: string | null;
};

export type ChoreList = { chores: Chore[]; open: number; total: number };
export type ChoreDraft = { title: string; body: string; link: string };

const json = (method: string, body: unknown): RequestInit => ({
  method,
  headers: { "content-type": "application/json" },
  body: JSON.stringify(body),
});

export const choresApi = {
  list: () => call<ChoreList>(`/chores`),
  create: (d: ChoreDraft) => call<Chore>(`/chores`, json("POST", d)),
  update: (id: string, patch: Partial<ChoreDraft> & { done?: boolean }) =>
    call<Chore>(`/chores/${encodeURIComponent(id)}`, json("PATCH", patch)),
  remove: (id: string) => call<void>(`/chores/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
export type ChoresApi = typeof choresApi;

/** 참고 칸이 링크로 그릴 주소인가 — 서버(`chores::link_ok`)는 다른 스킴을 이미 막는다. */
export const isWebLink = (s: string) => /^https?:\/\/\S/i.test(s.trim());
